import { Box } from '@quintoandar-tokko/jopijs';
import styles from './otherTooltip.module.scss';

export default function OtherTooltip({
  children,
  className = '',
  xAxisPosition = 'left',
  ...rest
}) {
  const xAxisClassNames = {
    left: styles.left,
    right: styles.right,
  };
  const classNames = `${styles.otherTooltip} ${
    xAxisClassNames[xAxisPosition] || styles.left
  } ${className}`;

  return (
    <Box className={classNames} {...rest}>
      {children}
    </Box>
  );
}
